import React, { useEffect } from 'react';

import PortalContext from '@/components/PortalContext';
import WEBVersionDetect from '@/components/WEBVersionDetect';
import TodoSocket from '@/components/TodoSocket';
import GroupOrderDetailDetect from '@/components/Order/DetailPortalDetect/Group';
import { automaticTimeCorrection } from '@/utils/overrideTime';

export default () => {
  useEffect(() => {
    // 校准时间
    automaticTimeCorrection();
  }, []);

  return (
    <>
      <PortalContext />
      <WEBVersionDetect />
      <TodoSocket />
      <GroupOrderDetailDetect />
    </>
  );
};
